(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/lyckoplatsen/shared/prolong-dialogs.js') >= 0) return;  svs.modules.push('/components/tur/lyckoplatsen/shared/prolong-dialogs.js');
"use strict";


const {
  CONSTANTS: {
    CHARITY_STATUS
  }
} = svs.tur.lyckoplatsen.shared;
const ACTIONS = {
  OK: {
    title: 'Okej'
  },
  CANCEL: {
    title: 'Avbryt'
  },
  LATER: {
    title: 'Senare'
  },
  DECLINE: {
    title: 'Jag avstår'
  },
  TO_GAMES: {
    title: 'Till spelen',
    callback: (_e, _forms, dialog) => {
      svs.utils.url.navigate(svs.core.urlMapping.get('myBetsHome'));
      dialog.close();
    }
  },
  createChooseAction: wagerId => ({
    title: 'Välj',
    callback: (_e, _forms, dialog) => {
      svs.utils.url.navigate("".concat(svs.core.urlMapping.get('lyckoplatsenHome'), "/relaterat/").concat(wagerId, "/-1"));
      dialog.close();
    }
  })
};
const showProlongedGeoDialog = _ref => {
  let {
    charity,
    wagerId
  } = _ref;
  const actions = [];
  let title;
  let messageText;
  if ((charity === null || charity === void 0 ? void 0 : charity.charityId) > 0 && charity !== null && charity !== void 0 && charity.name) {
    const messageTextValidCharity = "".concat(charity.name, " tackar f\xF6r ditt fortsatta bidrag.");
    const messageTextNotValidCharity = "Tyv\xE4rr \xE4r den h\xE4r organisationen inte l\xE4ngre m\xF6jlig att v\xE4lja.<br> Du kan v\xE4lja en annan organisation att st\xF6tta n\xE4r du tittar p\xE5 ditt spel i Mina spel.";
    const isValidCharity = charity && charity.status === CHARITY_STATUS.ACTIVE;
    title = 'Din lyckoplats är betald';
    messageText = isValidCharity ? messageTextValidCharity : messageTextNotValidCharity;
    actions.push(ACTIONS.OK);
  } else {
    title = 'Välj en organisation att stötta';
    messageText = 'Din lyckoplats är betald. Men ta chansen att stötta en organisation med 10% av insatsen. Det kostar inget extra, påverkar varken dina vinstchanser eller hur mycket du kan vinna.';
    actions.push(ACTIONS.DECLINE);
    actions.push(ACTIONS.createChooseAction(wagerId));
  }
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'thumbs-up',
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.CONFIRM,
    title,
    message: [{
      type: svs.components.dialog.message.TEXT,
      text: messageText,
      align: svs.components.dialog.message.align.CENTER
    }],
    actions
  }));
};
const showProlongedGeoDialogMulti = _ref2 => {
  let {
    successfulWagers,
    hasFailedWagers = false
  } = _ref2;
  const actions = [];
  const messages = [];
  let title;
  const hasMissingCharity = successfulWagers.some(_ref3 => {
    let {
      charity
    } = _ref3;
    return (charity === null || charity === void 0 ? void 0 : charity.charityId) <= 0 || !(charity !== null && charity !== void 0 && charity.charityId);
  });
  const invalidCharithys = successfulWagers.filter(_ref4 => {
    let {
      wasInvalidCharity
    } = _ref4;
    return wasInvalidCharity;
  });
  if (hasMissingCharity && invalidCharithys.length === 1 || invalidCharithys.length > 1) {
    title = 'Välj organisationer att stötta';
    messages.push('Dina lyckoplatser är betalda.<br> Men en eller flera organisationer du tidigare valt att ge 10 % av insatsen till är inte längre valbara.');
    messages.push('Gå till dina pågående spel i Mina spel och välj organisationer för dina lyckoplatser som saknar.');
    actions.push(ACTIONS.LATER);
    actions.push(ACTIONS.TO_GAMES);
  } else if (invalidCharithys.length === 1) {
    title = 'Välj en ny organisation att stötta';
    const wagerId = invalidCharithys[0].wagerId;
    messages.push('Din lyckoplats är betald.<br> Men organisationen du tidigare valt att ge 10 % av insatsen till är inte längre valbar. Välj en ny.');
    actions.push(ACTIONS.CANCEL);
    actions.push(ACTIONS.createChooseAction(wagerId));
  } else if (hasMissingCharity) {
    title = 'Välj en organisation att stötta';
    if (successfulWagers.length === 1) {
      const wagerId = successfulWagers[0].wagerId;
      messages.push('Din lyckoplats är betald. Du kan utan extra kostnad och påverkan på vinstchans bestämma till vilken organisation du vill ge 10% av insatsen.');
      actions.push(ACTIONS.CANCEL);
      actions.push(ACTIONS.createChooseAction(wagerId));
    } else {
      messages.push('Dina lyckoplatser är betalda. Du kan utan extra kostnad och påverkan på vinstchans bestämma till vilken organisation du vill ge 10% av insatsen.');
      messages.push('Gå till dina pågående spel i Mina spel och välj en organisation för varje plats.');
      actions.push(ACTIONS.LATER);
      actions.push(ACTIONS.TO_GAMES);
    }
  } else {
    const isMulti = successfulWagers.length > 1;
    title = isMulti ? 'Dina lyckoplatser är betalda' : 'Din lyckoplats är betald';
    const charityNames = successfulWagers.map(_ref5 => {
      let {
        charity
      } = _ref5;
      return charity.name;
    }).filter(name => name);
    let formattedCharityNames;
    const uniqueCharityNames = [...new Set(charityNames)];
    if (uniqueCharityNames.length === 1) {
      formattedCharityNames = uniqueCharityNames[0];
    } else {
      formattedCharityNames = "".concat(uniqueCharityNames.slice(0, -1).join(', '), " och ").concat(uniqueCharityNames[uniqueCharityNames.length - 1]);
    }
    messages.push("".concat(formattedCharityNames, " tackar f\xF6r ditt fortsatta bidrag."));
    actions.push(ACTIONS.OK);
  }
  if (hasFailedWagers) {
    messages.push('Något spel gick inte att betala och har därför exkluderats ur ditt köp. Priset justerades.');
  }
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'thumbs-up',
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.CONFIRM,
    title,
    message: messages.map(text => ({
      type: svs.components.dialog.message.TEXT,
      text,
      align: svs.components.dialog.message.align.CENTER
    })),
    actions
  }));
};
const showAlreadyProlongedDialogAsync = isSubscription => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'information',
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.CONFIRM,
    title: 'Du har redan förlängt detta spel',
    message: [{
      type: svs.components.dialog.message.TEXT,
      text: isSubscription ? 'Är du säker på att du vill prenumerera på detta spel?' : 'Är du säker på att du vill förlänga detta spel? Tänk på att det kan bli en dubblett.',
      align: svs.components.dialog.message.align.CENTER
    }],
    actions: [{
      type: svs.components.dialog.button.SECONDARY,
      title: 'Avbryt',
      callback: () => {
        resolve(false);
        dialog.close();
      }
    }, {
      type: svs.components.dialog.button.PRIMARY,
      title: isSubscription ? 'Prenumerera' : 'Förläng',
      callback: () => {
        resolve(true);
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
setGlobal('svs.tur.lyckoplatsen.shared', {
  showProlongedGeoDialog,
  showProlongedGeoDialogMulti,
  showAlreadyProlongedDialogAsync
});

 })(window);